const toObjectString = Object.prototype.toString

export function isExactObject(data: any) {
  return typeof data === 'object' && toObjectString.call(data) === '[object Object]'
}

export function isExactArray(data: any) {
  return typeof data === 'object' && toObjectString.call(data) === '[object Array]'
}

export function isExactString(data: any) {
  return toObjectString.call(data) === '[object String]'
}

export function getProperty(object: any, key: string) {
  return key.split('.').reduce((p, c) => p?.[c], object)
}